import React, { Component } from "react";
import { connect } from "react-redux";
import { View, Text, Dimensions, ScrollView } from "react-native";
import Colors from "@microdoing/shared/constants/Colors";
import {
  widthPercentageToDP as wp,
  heightPercentageToDP as hp,
} from "react-native-responsive-screen";
import moment from "moment-timezone";
import i18n from "@microdoing/shared/i18n";
import { getUserId } from "@microdoing/shared/services/user/selectors";
import { answerPollRequest } from "@microdoing/shared/services/poll/actions";
import { Header } from "../../components/common";
import PollBar from "./PollBar";
import theme from "app/Theme/Theme";

const { width } = Dimensions.get("window");

class PollScreen extends Component {
  keyExtractor = (item, index) => {
    return index.toString();
  };

  displayDate = date => {
    const current = moment().startOf("day");
    // const today = moment();
    const doneDate = moment.tz(date, this.props.timezone);
    // const doneDate = moment(date);
    const hour = doneDate.format("HH:mm");
    const lastDate = doneDate.startOf("day");
    const diff = current.diff(lastDate, "days");
    if (diff === 0) {
      return i18n.t("today-at", { hour });
    } else if (diff === 1) {
      return i18n.t("yesterday-at", { hour });
    }
    return i18n.t("ago-at", { days: diff, hour });
    // return `- Il y a ${diff} jours à ${doneDate.format('HH:mm')}`;
  };

  goBack = () => {
    this.props.navigation.goBack();
  };

  pressOption = answer => () => {
    this.props.answerPollRequest({
      answer,
      userId: this.props.userId,
      pollId: this.props.poll._id,
    });
  };

  getUserAnswer = () => {
    return this.props.poll.answers.find(
      el => el.user._id === this.props.userId,
    );
  };

  displayPoll = () => {
    const userAnswer = this.getUserAnswer();
    return this.props.poll.options.map((el, i) => {
      return (
        <PollBar
          onPress={this.pressOption(el.title)}
          isUserChoice={userAnswer ? userAnswer.answer === el.title : false}
          key={i}
          hasVoted={userAnswer ? true : false}
          title={el.title}
          percentage={
            this.props.poll.totalVotes
              ? el.votes / this.props.poll.totalVotes
              : 0
          }
        />
      );
    });
  };

  render() {
    return (
      <View style={styles.main}>
        <Header
          onPress={this.goBack}
          name={i18n.t("poll")}
          style={{ borderBottomWidth: 0 }}
        />
        <ScrollView style={styles.scrollView}>
          <Text style={styles.pollTitle}>{this.props.poll.title}</Text>
          {this.displayPoll()}
          {this.getUserAnswer() && (
            <Text style={styles.answer}>{i18n.t("thanks-voted")}</Text>
          )}
          {this.getUserAnswer() && (
            <Text
              style={[
                styles.answer,
                { color: theme.colors["neutral.900"], marginTop: 5 },
              ]}
            >
              {i18n.t("total-votes", { votes: this.props.poll.totalVotes })}
            </Text>
          )}
          <View style={{ flex: 1 }} />
        </ScrollView>
      </View>
    );
  }
}

const styles = {
  main: {
    flex: 1,
    backgroundColor: theme.colors["brand.500"],
    flexDirection: "column",
  },
  scrollView: {
    borderColor: theme.colors["neutral.white"],
    borderTopWidth: 1,
    borderTopRightRadius: 10,
    borderTopLeftRadius: 10,
    backgroundColor: theme.colors["neutral.white"],
    flexDirection: "column",
  },
  pollTitle: {
    fontSize: wp("7%"),
    color: theme.colors["neutral.900"],
    fontWeight: "bold",
    marginTop: 15,
    marginLeft: 20,
    marginRight: 20,
  },
  date: {
    color: Colors.dateBlue,
    marginTop: 4,
    fontSize: wp("3.2%"),
  },
  title: {
    marginTop: 10,
    marginBottom: 10,
    marginLeft: 15,
    fontWeight: "bold",
    color: theme.colors["neutral.900"],
    fontSize: wp("4.5%"),
  },
  answer: {
    marginTop: 15,
    textAlign: "center",
    fontSize: wp("4.5%"),
    color: theme.colors["brand.500"],
    fontWeight: "bold",
  },
};

const mapStateToProps = state => {
  const { requesting, poll } = state.poll;
  return {
    timezone: state.user.timezone,
    userId: getUserId(state),
    requesting,
    poll,
  };
};

export default connect(mapStateToProps, {
  answerPollRequest,
})(PollScreen);
